import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProgressMeetingStoreActions,
  ProgressMeetingStoreSelectors,
  ProgressMeetingStoreReducer,
} from './index';
import { ProgressMeetingReportDto } from '@cradua/data';

@Injectable()
export class ProgressMeetingFacade {
  constructor(
    private store: Store<
      ProgressMeetingStoreReducer.ProgressMeetingPartialState
    >
  ) {}

  projectManagementRecord$ = this.store.select(
    ProgressMeetingStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProgressMeetingStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProgressMeetingStoreSelectors.getProgressMeetingError
  );

  getselected() {
    return this.store.select(ProgressMeetingStoreSelectors.getSelected);
  }

  get isLoadingProgressMeeting() {
    this.store.dispatch(ProgressMeetingStoreActions.loadProgressMeeting());
    return this.store.select(
      ProgressMeetingStoreSelectors.loadingProgressMeeting
    );
  }

  get loadProgressMeeting() {
    this.store.dispatch(ProgressMeetingStoreActions.loadProgressMeeting());
    return this.store.select(
      ProgressMeetingStoreSelectors.getAllProgressMeeting
    );
  }

  searchProgressMeetingRecord(query) {
    this.store.dispatch(
      ProgressMeetingStoreActions.searchProgressMeetingRecord({ query })
    );
  }

  addProgressMeeting(newProgressMeeting: ProgressMeetingReportDto[]) {
    this.store.dispatch(
      ProgressMeetingStoreActions.addProgressMeeting({
        newProgressMeeting,
      })
    );
  }

  updateProgressMeeting(updateProgressMeeting: ProgressMeetingReportDto[]) {
    this.store.dispatch(
      ProgressMeetingStoreActions.updateProgressMeeting({
        updateProgressMeeting,
      })
    );
  }

  removeProgressMeeting(ids: string[]) {
    this.store.dispatch(
      ProgressMeetingStoreActions.removeProgressMeeting({ ids })
    );
  }
}
